/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_IcoInputs */

const cs_settings_office_ico = /** @type {(inputs: Settings_Office_IcoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO`)
};

const en_settings_office_ico = /** @type {(inputs: Settings_Office_IcoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO`)
};

/**
* | output |
* | --- |
* | "IČO" |
*
* @param {Settings_Office_IcoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_ico = /** @type {((inputs?: Settings_Office_IcoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_IcoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_ico(inputs)
	return cs_settings_office_ico(inputs)
});